import useFacebookAuth from 'Pages/facebookManament/hooks/useFacebookAuth'
import {FacebookLayoutGeneral} from 'Pages/facebookManament/layouts/general'
import FacebookService from 'Pages/facebookManament/services'
import {useEffect} from 'react'
import {useReducer} from 'react'
import {PageFacebookLogin} from '../login'
import {FacebookMessageConfirmOrderWrapper} from './components/wrapper'
import {FacebookMessageConfirmOrderProvider} from './provider'
import {facebookMessageConfirmOrderInitialState} from './provider/_initstate'
import {FacebookMessageConfirmOrderReducer} from './provider/_reducer'
import {useTranslation} from "react-i18next";

const PageFacebookAssignProductToComment = () => {
  const [state, dispatch] = useReducer(
    FacebookMessageConfirmOrderReducer,
    facebookMessageConfirmOrderInitialState,
  )

  return (
    <FacebookMessageConfirmOrderProvider value={{state, dispatch}}>
      <PageContainer />
    </FacebookMessageConfirmOrderProvider>
  )
}

export default PageFacebookAssignProductToComment

const PageContainer = () => {
  const {t} = useTranslation()
  const {facebookAuth, logout, getUser, setAuthData} = useFacebookAuth()
  const {auth} = facebookAuth

  useEffect(() => {
    FacebookService.initFacebookSdk({
      getAuthData: data => setAuthData(data),
    })
  }, [])

  useEffect(() => {
    document.title = t('facebookManament_assign_product_to_comment_title')
    if (auth.userId) getUser()
  }, [auth.userId])

  if (auth.userId)
    return (
      <FacebookLayoutGeneral
        title="facebookManament_configuration_setup"
        subTitle={t('facebookManament_assign_product_to_comment_title')}
        isUl={true}
        description={t('facebookManament_assign_product_to_comment_description')}
        breadcrumb={[{id: 1, name: t('back'), url: '/facebook', isBack: true}]}
        authData={facebookAuth}
        logout={logout}
      >
        <FacebookMessageConfirmOrderWrapper />
      </FacebookLayoutGeneral>
    )

  return <PageFacebookLogin connect={setAuthData} />
}

